<template>
  <div class="login-container">
    <a-card class="login-card" :bordered="false">
      <a href="https://quickguide-2fa-published-2mq4zmn.gamma.site/" target="_blank" rel="noopener noreferrer" class="info-link">
        <a-icon type="info-circle" /> Read Manual
      </a>
      <div class="login-header">
        <img src="/images/MUIC_Logo_Eng_Center.png" alt="MUIC Logo" class="login-logo" />
        <h1>MUIC Alumni Login</h1>
        <p>Sign in with your SKY+/MUIC Microsoft account</p>
      </div>
      <a-alert v-if="errorMessage" type="error" :message="errorMessage" show-icon class="login-error" />
      <a-button type="primary" size="large" block class="login-button" :loading="isLoading" @click="loginWithMicrosoft">
        Sign in with Microsoft Entra
      </a-button>
    </a-card>
  </div>
</template>

<script>
import authService from "../services/authService";

export default {
  name: "Login",
  data() {
    return { isLoading: false, errorMessage: "" };
  },
  async mounted() {
    document.body.classList.add("alumni-login-page");
    await authService.initialize();
    if (this.$route.query.error === "access_denied") {
      this.errorMessage = "Your session could not be verified. Please sign in again or contact support if the problem continues.";
    } else if (authService.isAuthenticated()) {
      this.$router.replace(authService.consumeReturnPath());
    }
  },
  beforeDestroy() {
    document.body.classList.remove("alumni-login-page");
  },
  methods: {
    async loginWithMicrosoft() {
      if (this.isLoading) return;
      this.isLoading = true;
      this.errorMessage = "";
      try {
        await authService.login();
      } catch (error) {
        console.error("Microsoft login failed", error);
        this.errorMessage = "Microsoft login failed. Please try again.";
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.login-container { min-height: 100vh; display: flex; align-items: center; justify-content: center; padding: 24px; background: #f0f2f5 url('/images/bg_sso_ic.jpg') center/cover no-repeat; }
.login-card { position: relative; width: 100%; max-width: 420px; border-radius: 10px; background: rgba(255,255,255,.96); box-shadow: 0 8px 30px rgba(0,0,0,.18); }
.info-link { position: absolute; top: 16px; right: 16px; color: #6b7280; font-size: 12px; }
.login-header { text-align: center; margin: 24px 0; }
.login-logo { width: 216px; max-width: 80%; margin-bottom: 20px; }
.login-header h1 { color: #502b80; font-size: 25px; margin-bottom: 6px; }
.login-header p { color: #6b7280; margin: 0; }
.login-error { margin-bottom: 16px; }
.login-button { height: auto; min-height: 48px; background: #502b80; border-color: #502b80; font-weight: 600; }
.login-button:hover, .login-button:focus { background: #674197; border-color: #674197; }
</style>

<style lang="scss">
body.alumni-login-page {
  padding: 0;
  overflow: hidden;
}

.layout-default.login-fullscreen {
  min-height: 100vh;

  > .ant-layout-content {
    padding-top: 0;
  }

  > .ant-layout-footer {
    display: none;
  }
}
</style>
